/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{VertexAttribute as t}from"../lib/VertexAttribute.js";import{writeDefaultAttributes as e}from"./internal/bufferWriterUtils.js";class r{constructor(t){this.vertexBufferLayout=t}elementCount(e){return e.attributes.get(t.POSITION).indices.length}write(t,r,i,o,s){e(i,this.vertexBufferLayout,t,r,o,s)}}export{r as DefaultBufferWriter};
